<template>
  <div class="ListagemCategorias">
    <div class="ListagemCategorias_header p-2">
      <div class="row">
        <div class="col-1">
          Ativo
        </div>
        <div class="col-2">
          Agrupar Lançamentos
        </div>
        <div class="col-2">
          Tipo de lançamento
        </div>
        <div class="col-2">
          Categoria/Tipo de ato
        </div>
        <div class="col-4">
          Ato
        </div>
        <div class="col-1" />
      </div>
    </div>
    <div v-for="(categoria, index) in propCategorias"
         :key="index"
         class="ListagemCategorias_item">
      <div class="row align-items-center">
        <div class="col-1 pl-4">
          <b-form-checkbox :id="`ativo_${index}`"
                           v-model="categoria.ativo"
                           switch
                           :value="1"
                           @change="atualizarCategoria(categoria)" />
        </div>
        <div class="col-2">
          <b-form-checkbox :id="`agrupado_${index}`"
                           v-model="categoria.agrupar"
                           switch
                           :value="1"
                           :disabled="categoria.tipo === 'DESPESA'"
                           @change="atualizarCategoria(categoria)" />
        </div>
        <div class="col-2">
          {{ categoria.tipo | firstCapitalize }}
        </div>
        <div class="col-2">
          {{ categoria.nome }}
        </div>
        <div class="col-4">
          {{ categoria.ato }}
        </div>
        <div class="
             col-1">
          <div class="row d-inline-flex justify-content-between p-2">
            <div @click="editarCategoria(categoria)">
              <icon-svg icon="pencil"
                        class="icon--sm icon-edit mr-4 icon-click" />
            </div>
            <div @click="excluirCategoria(categoria)">
              <icon-svg icon="trash"
                        class="icons--red icon--sm icon-click" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ListagemCategorias',
    props: {
      propCategorias: { type: Array, default: () => ([])}
    },
    methods: {
      async excluirCategoria (categoria) {
        const res = await displayMessage('question', 'Tem certeza que deseja excluir esta categoria?')

        if (res.value) {
          this.$emit('excluirCategoria', categoria)
        }
      },
      editarCategoria (categoria) {
        this.$emit('editarCategoria', categoria)
      },
      atualizarCategoria (categoria) {
        setTimeout(() => {
          categoria = {
            categoria_id: categoria.categoria_id,
            agrupar: categoria.agrupar,
            ativo: categoria.ativo
          }

          this.$emit('atualizarCategoria', categoria)
        }, 200)
      }
    }
  }
</script>

<style lang="scss">
  .ListagemCategorias {
    display: table;
    border-collapse: collapse;
    width: 100%;

    &_header {
      border-radius: 4px 4px 0px 0px;
      background-color: #01bfa5;
      color: #000;
      font-size: 16px;
      font-weight: bold;
    }

    &_item {
      color: #000;
      font-size: 16px;
      display: table-row;
      border: 1px solid #696969;
    }
  }

  .icon-edit {
    fill: #696969;
  }

  .icon-click {
    cursor: pointer;
  }
</style>
